module.exports = __webpack_public_path__ + "img/icon-arrow.46a974f4.svg";